import React from "react";
import { Route, Routes } from "react-router-dom";
import { containerUrl } from "../components/utils/constants";
import OcvScheduled from "../components/OcvScheduled/OcvScheduled";
import RegistrationLayout from "../components/Registration/Layout/Layout";
import SubmitAO from "../components/SubmitAO/SubmitAO";
import Poa from "../components/POA/Poa";
import InstanHelp from "../components/InstantHelp/InstantHelp";
import StatusLayout from "../components/Status/Layout/Layout";
import EsignMainPage from "../components/ESign/NewEsign/EsignMainPage";
import DeviceContext from "../components/Services/identifyDevice";
import EsignSubmit from "../components/EsignSubmit/EsignSubmit";
import KYCSubmit from "../components/KYCSubmit/KYCSubmit";
export interface SubmissionRoutesProps { }

const SubmissionRoutes: React.FC<SubmissionRoutesProps> = (props) => (
  <Routes>
    {/* <Route
      path={containerUrl.ocv}
      exact
      render={() => (
        <InstanHelp panPageFlag={false}>
          <RegistrationLayout isSubmissionRoute>
            <OcvScheduled />
          </RegistrationLayout>
        </InstanHelp>
      )}
    /> */}
    <Route
      path={containerUrl.poa}
      element={
        <InstanHelp panPageFlag={false}>
          <RegistrationLayout isSubmissionRoute>
            <Poa />
          </RegistrationLayout>
        </InstanHelp>
      }
    />
    <Route
      path={containerUrl.submit}
      element={
        <InstanHelp panPageFlag={false}>
          <RegistrationLayout isSubmissionRoute skipOption>
            <SubmitAO />
          </RegistrationLayout>
        </InstanHelp>
      }
    />
    <Route
      path={containerUrl.esignsubmit}
      element={
        <InstanHelp panPageFlag={false}>
          <StatusLayout>
            <EsignSubmit />
          </StatusLayout>
        </InstanHelp>
      }
    />
    <Route
      path={containerUrl.kycsubmit}
      element={
        <StatusLayout>
          <KYCSubmit />
        </StatusLayout>
        // <InstanHelp panPageFlag={false}>

        // </InstanHelp>
      }
    />
    <Route
      path={containerUrl.verify}
      element={
        <StatusLayout
          statusClassName={"statusLayoutNew"}
          edelLogoClass={"headerLogoLeftAlign"}
        >
          <EsignMainPage />
        </StatusLayout>
      }
    />
  </Routes>
);

export default SubmissionRoutes;
